import Footer from "../../components/Footer/Footer";
import Seo from "../../components/Seo/Seo";
import site from "../../data/site";
import { homeGraph } from "../../seo/schema";
import AboutUs from "./AboutUs";
import Banner from "./Banner";
import BookACall from "./BookACall";
import CompaniesWorkingWith from "./CompaniesWorkingWith";
import HowWeWork from "./HowWeWork";
import OurServices from "./OurServices";
import OurTeam from "./OurTeam";

function Home() {
  return (
    <main className="page">
      <Seo
        title={site.home.title}
        description={site.home.description}
        path="/"
        jsonLd={homeGraph()}
        preloadHero
      />
      <Banner />
      <OurServices />
      <HowWeWork />
      <CompaniesWorkingWith />
      <AboutUs />
      <OurTeam />
      <BookACall />
      <Footer />
    </main>
  );
}

export default Home;
